import { useTranslation } from 'next-i18next'
import Image from 'next/legacy/image'

import { SEO, Text, Accordion } from '@components'
import CommonPageLayout from '@layouts/CommonPageLayout'
import styles from './style.module.css'

import { convertToRoman } from '@utils/helpers'
import content from '@constants/faq'

function FAQModule() {
  const { i18n, t } = useTranslation('faq')
  const faqContent = content(t, i18n)

  return (
    <>
      <SEO
        title='BASE FAQ'
        description='Punya pertanyaan? Temukan jawaban dari pertanyaan yang sering ditanyakan di sini.'
      />

      <div className={styles.titleContainer}>
        <Text tag="h1" variant="title">
          {faqContent.title}
        </Text>
        <Text tag="h5" variant="heroDescription">
          {faqContent.description}
        </Text>
      </div>

      <Accordion multiple active={[0]}>
        {faqContent.data.map((content, index) => {
          return (
            <Accordion.Section
              key={`faq_page_${index}`}
              className={styles.faqSection}
            >
              <Accordion.Header>
                {activeSection => {
                  const isActive = activeSection.includes(index)

                  return (
                    <Text
                      tag="h2"
                      variant="subtitle"
                      className={styles.faqHeader}
                    >
                      {convertToRoman(index + 1)}. {content.title}
                      <span className={styles.chevron}>
                        <Image
                          alt="open faq"
                          src="https://static.base.co.id/chevron-black.svg"
                          layout="responsive"
                          height={9}
                          width={17}
                          className={isActive ? styles.up : undefined}
                        />
                      </span>
                    </Text>
                  )
                }}
              </Accordion.Header>

              <Accordion.Content>
                {content.list &&
                  content.list.length > 0 &&
                  content.list.map((eachFaq, listIndex) => (
                    <div
                      key={`faq_description_${index}_${listIndex}`}
                      className={styles.faqContent}
                    >
                      <Text tag="h3" variant="lightTitle">
                        {eachFaq.title}
                      </Text>

                      <div className={styles.faqDescription}>
                        {eachFaq.description}
                      </div>
                    </div>
                  ))}
              </Accordion.Content>
            </Accordion.Section>
          )
        })}
      </Accordion>
    </>
  )
}

FAQModule.getLayout = page => {
  return (
    <CommonPageLayout containerClassName={styles.pageContainer}>
      {page}
    </CommonPageLayout>
  )
}

export default FAQModule
